import { selector } from "recoil";
import { getSiteApi } from "../../services/apiCalls";

const getWayaPay = selector({
  key: "getWayaPay",
  get: async ({ get }) => {
    try {
      const result = await getSiteApi("waya_pay");
      return result.data || {};
    } catch (error) {
      console.error(`ERROR: \n${error}`);
      return {};
    }
  }
});

export default getWayaPay